module.exports = __webpack_public_path__ + "image/about_image_4_371e9.png";